type PropsType = {
  children: React.ReactNode;
};

export const FormSubmitRow = (props: PropsType) => {
  return <div className="submit-row">{props.children} </div>;
};
